// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-create/inventory-create.less
// module id = 3460
// module chunks = 0